import type { WiringInstructions } from '@Types/WiringInstrucions.interface';
import { BankWireStatus } from '@Shared';

export const useWiringInstructionsForm = () => {

    const sanitizeAccountName = (val: string): string => {
        if (!val) return '';
        const parts = val.match(/[a-zA-Z0-9,.<>?/|\\'"(){}[\]!@#$;:%^&~`_\-+=* ]+/g);
        return parts ? parts.join('') : '';
    };

    const sanitizeAccountNumber = (val: string): string => {
        if (!val) return '';
        const parts = val.match(/[a-zA-Z0-9-]+/g);
        return parts ? parts.join('') : '';
    };

    const createEmptyWiringInstructions = (): WiringInstructions => {
        const addr = () => ({ address1: '', address2: '', city: '', state: '', postalCode: '' });
        const creditAccount = () => ({ accountName: '', accountNumber: '', accountAddress: addr(), isEmpty: true });
        return {
            id: '',
            name: '',
            defaultInstructions: '',
            beneficiaryBank: { id: '', name: '', routingNumber: '', address: addr(), phone: '', logoUrl: '', wireStatus: BankWireStatus.Valid },
            correspondentBank: { id: '', name: '', routingNumber: '', address: addr(), phone: '', logoUrl: '', wireStatus: BankWireStatus.Valid },
            creditTo: creditAccount(),
            furtherCreditTo: creditAccount(),
            personalAddress: addr(),
            bankAccountInfo: { accountType: null, isJoint: false, isTrust: false },
            isShared: null,
            bankName: null,
            accountNumber: null,
            routingNumber: null,
            accountType: null,
            accountHolderName: null,
        };
    };

    return { createEmptyWiringInstructions, sanitizeAccountName, sanitizeAccountNumber };
};

export default useWiringInstructionsForm;
